import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DefaultService } from "src/app/services/default/default.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-old-studio",
  templateUrl: "./old-studio.component.html",
  styleUrls: ["./old-studio.component.scss"],
})
export class OldStudioComponent implements OnInit {
  constructor(
    private defaultService: DefaultService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((route) => {
      let id = route.id;
      if (id == null || id == undefined || id == "") {
        window.top.location.href = environment.webflow_url + "/studios/404";
      }

      this.get_studios(id);
    });
  }

  get_studios(old_id: string) {
    this.defaultService
      .public_get_with_full_route(
        "studios-deleted/get/studio-by-old-id/" + old_id
      )
      .subscribe(
        (res) => {
          if (
            res.webflow_slug != "" &&
            res.webflow_slug != undefined &&
            res.webflow_slug != null
          ) {
            window.top.location.href =
              environment.webflow_url + "/studios/" + res.webflow_slug;
          } else {
            window.top.location.href = environment.webflow_url + "/studios/404";
          }
        },
        (err) => {
          window.top.location.href = environment.webflow_url + "/studios/404";
        }
      );
  }
}
